import { Component, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { CardComponent } from "common/card/card.component";
import { ToolbarItem } from "common/toolbar/toolbar-item.interface";
import { NgTemplateOutlet, NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MenuComponent } from "common/menu/menu.component";

@Component({
	selector: "stages-toolbar",
	templateUrl: "./toolbar.component.html",
	styleUrls: ["toolbar.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgTemplateOutlet, NgClass, TranslateModule, MenuComponent],
})
export class ToolbarComponent {
	readonly card = inject(CardComponent);

	readonly toolbarId = input<string>();

	readonly items = input<ToolbarItem[]>();

	isIE: boolean = false;

	constructor() {
		const card = this.card;

		this.isIE = card.isIE;
	}
}
